import { render, staticRenderFns } from "./CTransfTree.vue?vue&type=template&id=d9a889f8&scoped=true&"
import script from "./CTransfTree.vue?vue&type=script&lang=ts&"
export * from "./CTransfTree.vue?vue&type=script&lang=ts&"
import style0 from "./CTransfTree.vue?vue&type=style&index=0&id=d9a889f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a889f8",
  null
  
)

export default component.exports